import { slicePrefix } from '../config'

const createValue = slicePrefix('federal-district')

export const config = {
  modelName: createValue(),
} as const
